import React, { useState, useEffect } from "react";
import "./index.css";

const Carousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Array of images for the carousel
  const images = [
    {
      src: "images/battlefield-6-homepage.jpg",
      alt: "Battlefield 6",
      title: "Who are we?",
      content:
        "The 5th Marine Regiment was created in March 2025. Our aim is to create a big, active clan and community, where everyone can get along and sit down whenever to play some games.\n\nWe operate with no hour requirements! What this means, is that you can play with others whenever with no restriction of having to play at certain times, or have any activity restrictions",
    },
    {
      src: "images/Battlefield-6-homepage2.jpg",
      alt: "Battlefield 6 Square",
      title: "What Do We Offer?",
      content:
        "A Custom Discord Bot \n\n1 Squad Server \n\nOrganised Operations+Events \n\nNo Activity Requirements \n\nPlayers On Every Night \n\nOraganised Teamplay, No Man Left Behind \n\n24/7 Staff Coverage",
    },
    {
      src: "images/Battlefield-6-homepage3.jpg",
      alt: "Enlisted",
      title: "Why Join Us?",
      content:
        "We care about you. We never leave anyone out of anything. We want to make a family, and family stick together. We also have cookies",
    },
    {
      src: "images/Battlefield-6-homepage4.jpg",
      alt: "Hell Let Loose",
      title: "Any Questions?",
      content:
        "Join the discord, and open a support ticket. Our staff is online 24/7, and were happy to help. Your concerns are our top priority. We want to make this place the best for everyone, so everyone feels included",
    },
  ];

  // Auto-advance carousel every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) =>
        prevSlide === images.length - 1 ? 0 : prevSlide + 1
      );
    }, 30000);

    return () => clearInterval(timer);
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrevious = () => {
    setCurrentSlide(currentSlide === 0 ? images.length - 1 : currentSlide - 1);
  };

  const goToNext = () => {
    setCurrentSlide(currentSlide === images.length - 1 ? 0 : currentSlide + 1);
  };

  return (
    <div className="carousel-container">
      <div className="carousel-wrapper">
        <div
          className="carousel-slides"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {images.map((image, index) => (
            <div key={index} className="carousel-slide">
              <img src={image.src} alt={image.alt} className="carousel-image" />
              <div className="carousel-overlay">
                <div className="carousel-content">
                  <h2 className="carousel-title">{image.title}</h2>
                  <p className="carousel-text">{image.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation arrows */}
        <button
          className="carousel-arrow carousel-arrow-left"
          onClick={goToPrevious}
        >
          &#8249;
        </button>
        <button
          className="carousel-arrow carousel-arrow-right"
          onClick={goToNext}
        >
          &#8250;
        </button>

        {/* Dots indicator */}
        <div className="carousel-dots">
          {images.map((_, index) => (
            <button
              key={index}
              className={`carousel-dot ${
                index === currentSlide ? "active" : ""
              }`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
